const moduleHome = {
	namespaced: true,
	state: {
		PRELOAD_IMGLIST: [],		// 预加载图片
		FULLPAGE: null,		// home 全屏滚动类
	},
	mutations: {
		SET_PRELOADIMGLIST: (state, params) => {
			state.PRELOADIMGLIST = params
		},
		INIT_FULLPAGE: (state, params) => {
			state.FULLPAGE = params
		},
	},
	actions: {
	},
	getters: {
		NAV_ACTIVE_INDEX: state => {
			if(state.FULLPAGE) {
				return state.FULLPAGE.activeIndex
			} else {
				return -1
			}
		}
	}
}

export default moduleHome
